import React from 'react'
import { ClassroomManager } from '@helpers'
import { useClassroomPermissions } from '../../../contexts'
import { Classroom as CC } from '@constants'

const Toolbar = () => {
  const { checkPermission } = useClassroomPermissions()
  const canTogglePanels = checkPermission(CC.FEATURES.TOOL_PANEL_TOGGLE)
  return (
    <div className='gp-Media-toolbar'>
      {/*<div className='control-container dark'>
        <button onClick={() => ClassroomManager.closePanels()} title='Minimize'>
          <div>
            <div style={{ height: 2 }} />
          </div>
        </button>
      </div> */}
      <div className='control-container dark'>
        <button
          className='active'
          onClick={() => {}}
          title='Show current speaker'
        >
          <div>
            <div style={{ height: 6 }} />
          </div>
        </button>
      </div>
      <div className='control-container dark'>
        <button
          disabled={!canTogglePanels}
          onClick={() => {
            if (!canTogglePanels) {
              return
            }
            ClassroomManager.closePanels()
          }}
          title='Show everyone'
        >
          <div>
            <div style={{ height: 10 }} />
          </div>
        </button>
      </div>
    </div>
  )
}

export default Toolbar
